import { mapGetters, mapActions } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
const whiteList = ['grocery', 'restaurants', 'parks', 'cafes'];
export default {
    name: 'propertyPoi',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
    },
    props: ['disableCollapse', 'isActive'],
    methods: {
        ...mapActions('dpp', ['fetchNearbyPois']),
        select(index) {
            this.index = index;
        },
        popMapView(params) {
            this.$eventBus.$emit('property-pop-map', params);
        },
        toggleShowMore() {
            this.showMore = !this.showMore;
        },
    },
    data() {
        return {
            index: 0,
            showMore: false,
        };
    },
    mounted() {
        var data = {
            latitude: this.dpp.geo.lat,
            longitude: this.dpp.geo.lng,
            propertyId: this.dpp.propertyId,
        };
        this.fetchNearbyPois(data);
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        getNearbyPois() {
            let categories = [];
            if (this.dpp.nearbyPois && this.dpp.nearbyPois.length) {
                for (const cate of whiteList) {
                    let category = this.dpp.nearbyPois.find((poi) => poi.type === cate);
                    if (category) {
                        categories.push(category);
                    }
                }
            }
            return categories;
        },
        selectedPois() {
            if (this.getNearbyPois && this.getNearbyPois.length) {
                return this.getNearbyPois[this.index];
            }
            return [];
        },
        filteredPois() {
            if (this.selectedPois && this.selectedPois.list) {
                let reuslt = this.selectedPois.list.sort((a, b) => a.distance - b.distance);
                if (this.showMore) {
                    return reuslt;
                }
                return reuslt.slice(0, 5);
            }
            return [];
        },
    },
};
